import { render, staticRenderFns } from "./PartnerProgram.vue?vue&type=template&id=64981ffa&scoped=true&"
import script from "./PartnerProgram.vue?vue&type=script&lang=js&"
export * from "./PartnerProgram.vue?vue&type=script&lang=js&"
import style0 from "./PartnerProgram.vue?vue&type=style&index=0&id=64981ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64981ffa",
  null
  
)

export default component.exports